import React from 'react';
import { IIconProps } from './utils';

export const Overview = ({
  fill = 'currentColor', height = 30, width = 30, ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 30"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      clipRule="evenodd"
      d="M17.9772 7.22653C15.0085 4.25782 10.1952 4.25782 7.22653 7.22653C4.25782 10.1952 4.25782 15.0085 7.22653 17.9772C7.71469 18.4653 7.71469 19.2568 7.22653 19.7449C6.73837 20.2331 5.94692 20.2331 5.45876 19.7449C1.51375 15.7999 1.51375 9.40378 5.45876 5.45876C9.40378 1.51375 15.7999 1.51375 19.7449 5.45876C20.2331 5.94692 20.2331 6.73837 19.7449 7.22653C19.2568 7.71469 18.4653 7.71469 17.9772 7.22653ZM15.2946 9.90904C13.8075 8.42185 11.3962 8.42185 9.90904 9.90904C9.42089 10.3972 8.62943 10.3972 8.14127 9.90904C7.65312 9.42089 7.65312 8.62943 8.14127 8.14128C10.6048 5.67777 14.5989 5.67777 17.0624 8.14128C17.5506 8.62943 17.5506 9.42089 17.0624 9.90904C16.5743 10.3972 15.7828 10.3972 15.2946 9.90904ZM20.9838 9.48738C21.6584 9.34039 22.3243 9.76804 22.4713 10.4426C23.0946 13.3027 22.4635 16.3859 20.5746 18.8069L22.9162 21.1484C23.5301 21.0034 24.2027 21.1704 24.6815 21.6492L26.9487 23.9164C27.6838 24.6515 27.6838 25.8432 26.9487 26.5783L26.5783 26.9487C25.8432 27.6838 24.6515 27.6838 23.9164 26.9487L21.6492 24.6815C21.1704 24.2027 21.0034 23.5301 21.1484 22.9162L18.8069 20.5746C16.3589 22.4846 13.2341 23.1085 10.347 22.45C9.67396 22.2965 9.25278 21.6264 9.4063 20.9534C9.55981 20.2803 10.2299 19.8591 10.903 20.0126C13.3708 20.5755 16.0591 19.8953 17.9772 17.9772C19.8767 16.0777 20.5622 13.423 20.0287 10.9749C19.8817 10.3003 20.3093 9.63437 20.9838 9.48738ZM23.4169 22.9137C23.4172 22.914 23.4176 22.9143 23.4179 22.9146L23.4169 22.9137Z"
      fill={fill}
      fillRule="evenodd"
    />
  </svg>
);
